import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <>
      <SEO 
        title="Side ikke funnet (404)"
        description="Beklager, siden du leter etter finnes ikke. Gå tilbake til forsiden eller kontakt oss for hjelp."
        noindex={true}
      />
      <Header />
      
      <main className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center px-4">
        <div className="max-w-2xl mx-auto text-center py-20">
          {/* 404 Graphic */}
          <div className="relative mb-8">
            <h1 className="text-[150px] md:text-[200px] font-black text-gray-800 leading-none select-none">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-gradient-to-r from-red-600 to-yellow-500 bg-clip-text text-transparent text-4xl md:text-5xl font-bold">
                Oops!
              </div>
            </div>
          </div>

          {/* Error Message */}
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Siden ble ikke funnet
          </h2>
          <p className="text-gray-400 text-lg mb-8 max-w-md mx-auto">
            Beklager, siden du leter etter eksisterer ikke, har blitt flyttet, eller er midlertidig utilgjengelig.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link to="/">
              <Button 
                size="lg"
                className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold w-full sm:w-auto"
              >
                <Home className="w-5 h-5 mr-2" />
                Til forsiden
              </Button>
            </Link>
            <Button 
              variant="outline"
              size="lg"
              className="border-gray-600 text-gray-300 hover:bg-gray-800 w-full sm:w-auto"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Gå tilbake
            </Button>
          </div>

          {/* Helpful Links */}
          <div className="border-t border-gray-700 pt-8">
            <p className="text-gray-500 mb-4">Kanskje du leter etter:</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link 
                to="/#services" 
                className="text-red-400 hover:text-red-300 transition-colors flex items-center gap-1"
              >
                <Search className="w-4 h-4" />
                Våre tjenester
              </Link>
              <Link 
                to="/kontakt" 
                className="text-red-400 hover:text-red-300 transition-colors flex items-center gap-1"
              >
                <Phone className="w-4 h-4" />
                Kontakt oss
              </Link>
              <Link 
                to="/aktuelt" 
                className="text-red-400 hover:text-red-300 transition-colors"
              >
                Aktuelt
              </Link>
              <Link 
                to="/kampanjer" 
                className="text-red-400 hover:text-red-300 transition-colors"
              >
                Kampanjer
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default NotFound;
